(function () {
    const trigger = document.querySelector('[data-virtual-try-on-trigger]');
    const modal = document.getElementById('virtualTryOnModal');

    if (!trigger || !modal) return;

    const loadingOverlay = modal.querySelector('.loading-overlay');
    const loadingStatus = modal.querySelector('[data-virtual-try-on-loading-status]');
    const errorElement = modal.querySelector('.error-message');
    const closeButton = modal.querySelector('[data-close-virtual-try-on]');
    const originalButtonLabel = trigger.querySelector('span')?.textContent;
    const dependencyUrls = {
        tensorflowCore: 'https://unpkg.com/@tensorflow/tfjs-core@3.11.0/dist/tf-core.js',
        tensorflowConverter: 'https://unpkg.com/@tensorflow/tfjs-converter@3.11.0/dist/tf-converter.js',
        tensorflowWebgl: 'https://unpkg.com/@tensorflow/tfjs-backend-webgl@3.11.0/dist/tf-backend-webgl.js',
        faceLandmarks: 'https://unpkg.com/@tensorflow-models/face-landmarks-detection@0.0.3/dist/face-landmarks-detection.js',
        mediaPipeFaceMesh: 'https://unpkg.com/@mediapipe/face_mesh@0.4.1633559619/face_mesh.js'
    };

    let loadPromise;
    let instance;
    let shouldOpen = false;

    function setPreparing(isPreparing) {
        const buttonLabel = trigger.querySelector('span');

        trigger.disabled = isPreparing;
        trigger.setAttribute('aria-busy', String(isPreparing));
        loadingOverlay.style.display = isPreparing ? 'flex' : 'none';

        if (isPreparing) {
            errorElement.style.display = 'none';
            loadingStatus.textContent = trigger.dataset.preparingText;
            if (buttonLabel) buttonLabel.textContent = trigger.dataset.preparingText;
        } else if (buttonLabel && originalButtonLabel) {
            buttonLabel.textContent = originalButtonLabel;
        }
    }

    function loadScript(src) {
        const loadedScript = Array.from(document.scripts).find((script) => script.src === src);

        if (loadedScript?.dataset.virtualTryOnLoaded === 'true') {
            return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
            const script = loadedScript || document.createElement('script');

            const handleLoad = () => {
                script.dataset.virtualTryOnLoaded = 'true';
                resolve();
            };
            const handleError = () => {
                script.remove();
                reject(new Error(`Failed to load ${src}`));
            };

            script.addEventListener('load', handleLoad, { once: true });
            script.addEventListener('error', handleError, { once: true });

            if (!loadedScript) {
                script.src = src;
                script.async = false;
                document.head.appendChild(script);
            }
        });
    }

    async function prepareTryOn() {
        // The local controller has no top-level dependency on the recognition
        // libraries, so its download can overlap with the CDN requests.
        const virtualTryOnScriptPromise = loadScript(
            new URL(trigger.dataset.virtualTryOnScript, window.location.href).href
        );
        virtualTryOnScriptPromise.catch(() => {});

        // MediaPipe is independent of TensorFlow. Start both downloads together,
        // then parallelize the two packages that only depend on tfjs-core.
        await Promise.all([
            loadScript(dependencyUrls.tensorflowCore),
            loadScript(dependencyUrls.mediaPipeFaceMesh)
        ]);
        await Promise.all([
            loadScript(dependencyUrls.tensorflowConverter),
            loadScript(dependencyUrls.tensorflowWebgl)
        ]);
        await Promise.all([
            loadScript(dependencyUrls.faceLandmarks),
            virtualTryOnScriptPromise
        ]);

        if (!window.VirtualTryOn) {
            throw new Error('Virtual try-on did not initialize');
        }

        instance = new window.VirtualTryOn();
        await instance.ready;
        return instance;
    }

    function getLoadPromise() {
        if (!loadPromise) {
            const currentPromise = prepareTryOn();
            loadPromise = currentPromise;

            // A failed hover/focus warm-up must not prevent a click from retrying.
            currentPromise.catch(() => {
                if (loadPromise === currentPromise) {
                    loadPromise = null;
                    instance = null;
                }
            });
        }

        return loadPromise;
    }

    function warmUpTryOn() {
        getLoadPromise().catch(() => {
            // The visible error state is handled only after an explicit click.
        });
    }

    trigger.addEventListener('pointerenter', warmUpTryOn, { once: true });
    trigger.addEventListener('focus', warmUpTryOn, { once: true });
    trigger.addEventListener('touchstart', warmUpTryOn, { once: true, passive: true });

    trigger.addEventListener('click', async () => {
        shouldOpen = true;
        modal.style.display = 'flex';
        setPreparing(true);

        try {
            const virtualTryOn = await getLoadPromise();

            setPreparing(false);
            if (shouldOpen) await virtualTryOn.openModal();
        } catch (error) {
            console.error('Virtual try-on loading failed:', error);
            loadPromise = null;
            instance = null;
            setPreparing(false);
            errorElement.textContent = trigger.dataset.loadErrorText;
            errorElement.style.display = 'block';
        }
    });

    closeButton?.addEventListener('click', () => {
        shouldOpen = false;
        if (instance) {
            instance.closeModal();
        } else {
            modal.style.display = 'none';
        }
    });
})();
